module.exports = __webpack_public_path__ + "img/169-liberia.a3790fa5.svg";